import { Grid } from '@mui/material';
import { FieldValues, UseFormResetField, useFormContext } from 'react-hook-form';
import { RenderInput } from 'ui-component/RecordView/components';
import { IRecordField, IRecordFieldWithFieldName } from 'ui-component/records/types';

export type FormInputProps = {
    label: string;
    name: string;
    fieldDef?: IRecordField;
    options?: any[];
    isCustomList?: boolean;
    resetField?: UseFormResetField<FieldValues>;
};

export const FormInput = ({ label, name, fieldDef, options, isCustomList, resetField }: FormInputProps) => {
    const { control } = useFormContext();

    const newFieldDef: IRecordFieldWithFieldName = {
        ...(fieldDef as IRecordFieldWithFieldName),
        dataType: fieldDef?.dataType ?? 'string',
        gridEditable: fieldDef?.gridEditable ?? true,
        required: fieldDef?.required ?? false,
        headerField: fieldDef?.headerField ?? false,
        field: fieldDef?.field ?? name,
        description: fieldDef?.description || '',
        visibility: fieldDef?.visibility || 'standard'
    };

    return (
        <Grid item xs="auto" width="100%">
            <RenderInput
                control={control}
                options={options}
                isCustomList={isCustomList}
                errors={{}}
                fieldData={newFieldDef}
                name={name}
                label={label}
                resetField={resetField}
            />
        </Grid>
    );
};
